import type { ReactNode } from 'react';
import { PanelHeader } from './PanelHeader';

export function Panel({
  title,
  headerRight,
  children,
  style,
  bodyClassName = 'panel-body',
}: {
  title?: ReactNode;
  headerRight?: ReactNode;
  children: ReactNode;
  style?: React.CSSProperties;
  bodyClassName?: string;
}) {
  return (
    <div className="pixel-panel pixel-panel--parchment" style={{ padding: 0, ...style }}>
      {title && <PanelHeader right={headerRight}>{title}</PanelHeader>}
      <div className={bodyClassName}>{children}</div>
    </div>
  );
}
